import { Box, Divider, Grid, IconButton, Stack, Typography } from '@mui/material';
import React, { useState, useEffect, useCallback } from 'react';
import Iconify from '../iconify';
import number2Digits from '../../utils/general';
import moment from 'moment';
import { getAnalyticsPathologiesMetrics } from '../../services/analyticsService';
import LoadingContainer from '../loaders/LoadingContainer';
import useInitState from '../../hooks/useInitState';
import GlobalPyramidChart from './global/GlobalPyramidChart';
import GlobalRiskGroupChart from './global/GlobalRiskGroupChart';
import GlobalPathologiesChart from './global/GlobalPathologiesChart';
import { getAppointmentTypeGroupData, getDoubleAppointmentTypeGroupData, getICCByGenderGroupByDiagnostic, getIMCGroupByDiagnostic, getObjectiveByGroupData, getPathologiesAnalyticsData, getRiskGroupByDiagnostic, onGetCurrentPeriod, onGetFirstTimeAndFollowUpPatients } from '../../pages/Businesses/BusinessProgramPage/analytics_utils';
import GlobalIMCPieChart from './global/GlobalIMCPieChart';
import GlobalIccPieChartV2 from './global/GlobalIccPieChartV2';
import GlobalPatientAttentionChart from './global/GlobalPatientAttentionChart';
import GlobalAppointmentMotiveChart from './global/GlobalAppointmentMotiveChart';
import GlobalPyramidGroup from './global/GlobalPyramidGroup';
import usePatientData from '../../hooks/api/usePatientData';

const GlobalReport = ({
    idclient, 
    idclientprogram, 
    period,
    onReturn,
    appointments,
    program_users,
    locations
}) => {

    const {
        loading
    } = useInitState()

    const [global_patient, setGlobalPatient] = useState()
    const [pathologies, setPathologies] = useState()
    const [risk_group, setRiskGroup] = useState([])
    const patientDataManager = usePatientData()

    const [global_data, setGlobalData] = useState()
    const [appointment_type_data, setAppointmentTypeData] = useState({
        follow_up:null,
        first_time:null,
        double_appointments:null
    })
    const [appointment_objective_data, setAppointmentObjectiveData] = useState({
        follow_up:null,
        first_time:null
    })
    const [risk_group_data, setRiskGroupData] = useState({
        follow_up_users:null,
        first_time_users:null
    })
    const [imc_data, setIMCData] = useState({
        follow_up_users:null,
        first_time_users:null
    })
    const [pathologies_data, setPathologiesData] = useState({
        first_time_users:null,
        follow_up_users:null,
    })
    const [icc_data, setICCData] = useState({
        follow_up_male:null,
        first_time_male:null,
        follow_up_female:null,
        first_time_female:null
    })


    const initialize = useCallback(async() => {
        const month = number2Digits((period?.month ?? 0)+1)
        const year = period?.year
        const startdate = `${year}-${month}-01` 
        const enddate = moment(startdate).endOf('month').format('YYYY-MM-DD')

        loading.onTrue()

        try {

            const _pathologiespdata = await getAnalyticsPathologiesMetrics({
                start_date:startdate,
                end_date:enddate,
                client_id:idclient,
                client_program_id:idclientprogram
            })
            //console.log(_pathologiespdata)
            setPathologies(_pathologiespdata)
            //setGlobalPatient(_patientdata)
            
        } catch (error) {
            console.log(error)
        }
       
        loading.onFalse()

    }, [period, idclient, idclientprogram])

    useEffect(() => {
        initialize()
    }, [])


     const onGetLocalData = useCallback(async() => {
    
            const validPeriod = onGetCurrentPeriod(period)
            
            let patient_info = {}
            patient_info.total = program_users.length
    
            const {follow_up_users, first_time_users, valid_period_appointments, scheduled_appointments} = onGetFirstTimeAndFollowUpPatients(program_users, appointments, validPeriod)

            let patients_data = []

            try {
                const response = await patientDataManager.actions.onGetPatientDatasByClient(idclient)
                console.log(response)
                patients_data = response
            } catch (error) {
                
            }

            //console.log("Scheudled", scheduled_appointments)
            setGlobalData({
                first_time_users:first_time_users.length,
                follow_up_users:follow_up_users.length,
                pending_users: program_users.length - first_time_users.length - follow_up_users.length -scheduled_appointments.length,
                scheduled_appointments: scheduled_appointments.length
            })

            // Appointment Type Group

            const first_time_appointment_type = getAppointmentTypeGroupData(first_time_users)
            const followup_appointment_type = getAppointmentTypeGroupData(follow_up_users)
            const double_appointment_type = getDoubleAppointmentTypeGroupData([...first_time_users,...follow_up_users])

            setAppointmentTypeData({
                first_time:first_time_appointment_type,
                follow_up:followup_appointment_type,
                double_appointments:double_appointment_type,
            })

            // Appointment Type Group
            const first_time_appointment_objective = getObjectiveByGroupData(first_time_users)
            const followup_appointment_objective = getObjectiveByGroupData(follow_up_users)

            setAppointmentObjectiveData({
                first_time:first_time_appointment_objective,
                follow_up:followup_appointment_objective,
            })


            // Get risk group
            const first_time_riskgroup = getRiskGroupByDiagnostic(first_time_users)
            const followup_riskgroup = getRiskGroupByDiagnostic(follow_up_users)
            setRiskGroupData({
                follow_up:followup_riskgroup,
                first_time:first_time_riskgroup
            })

            // Get pathologies diagnostic
            const first_time_pathologies = getPathologiesAnalyticsData(first_time_users)
            const followup_pathologies = getPathologiesAnalyticsData(follow_up_users)
            setPathologiesData({
                first_time:first_time_pathologies,
                follow_up:followup_pathologies,
            })

            // Get imc diagnostic
            const first_time_imc = getIMCGroupByDiagnostic(first_time_users)
            const followup_imc = getIMCGroupByDiagnostic(follow_up_users)
            setIMCData({
                follow_up:followup_imc,
                first_time:first_time_imc
            })
            // Get icc diagnostic
            const first_time_icc_male = getICCByGenderGroupByDiagnostic(first_time_users,1)
            const followup_icc_male = getICCByGenderGroupByDiagnostic(follow_up_users,1)
            const first_time_icc_female = getICCByGenderGroupByDiagnostic(first_time_users,2)
            const followup_icc_female = getICCByGenderGroupByDiagnostic(follow_up_users,2)

            setICCData({
                first_time_male:first_time_icc_male,
                follow_up_male:followup_icc_male,
                first_time_female:first_time_icc_female,
                follow_up_female:followup_icc_female,
            })

    },[period, appointments, program_users, idclient])

    useEffect(() => {
        //console.log("verificar")
        onGetLocalData()
    },[period, appointments, program_users])

    return ( 
        <Box>
            <Stack direction='row'>
                <IconButton onClick={onReturn}>
                    <Iconify icon="material-symbols:arrow-back-rounded" />
                </IconButton>
                <Typography variant='h5'>
                    Datos Globales
                </Typography>
                
            </Stack>
            <Box sx={{py:3}}>
                <LoadingContainer loading={loading.value}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <GlobalPyramidGroup 
                                    period={period}
                                    appointments={appointments}
                                    locations={locations}
                                    program_users={program_users}

                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <GlobalPatientAttentionChart 
                                    first_time_data={appointment_type_data.first_time}
                                    follow_up_data={appointment_type_data.follow_up}
                                    double_appointments={appointment_type_data.double_appointments}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <GlobalAppointmentMotiveChart 
                                    first_time_data={appointment_objective_data.first_time}
                                    follow_up_data={appointment_objective_data.follow_up}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <GlobalRiskGroupChart 
                                    data={risk_group}
                                    first_time_data={risk_group_data.first_time}
                                    follow_up_data={risk_group_data.follow_up}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <GlobalPathologiesChart 
                                    first_time_data={pathologies_data.first_time}
                                    follow_up_data={pathologies_data.follow_up}
                                    {...pathologies}
                                />
                            </Grid>
                            {/*<Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <GlobalAnthropometricChart 
                                    idclient={idclient}
                                    idclientprogram={idclientprogram}
                                    period={period}
                                />
                            </Grid>*/}
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <GlobalIMCPieChart 
                                    idclient={idclient}
                                    idclientprogram={idclientprogram}
                                    period={period}
                                    first_time_data={imc_data.first_time}
                                    follow_up_data={imc_data.follow_up}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <GlobalIccPieChartV2
                                    idclient={idclient}
                                    idclientprogram={idclientprogram}
                                    period={period}
                                    first_time_male_data={icc_data.first_time_male}
                                    follow_up_male_data={icc_data.follow_up_male}
                                    first_time_female_data={icc_data.first_time_female}
                                    follow_up_female_data={icc_data.follow_up_female}
                                />
                            </Grid>
                        </Grid>
                    </LoadingContainer>
            </Box>
            
        </Box>
     );
}
 
export default GlobalReport;